import { useState, useEffect, useRef } from 'react';

const useAnimatedCounter = (targetValue, duration = 500) => {
  const [displayValue, setDisplayValue] = useState(targetValue);
  const prevValueRef = useRef(targetValue);

  useEffect(() => {
    const startValue = prevValueRef.current;
    const difference = targetValue - startValue;
    
    // Se não houver mudança, não faz nada
    if (difference === 0) return;

    let startTime = null;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      
      const animatedValue = Math.floor(startValue + difference * progress);
      setDisplayValue(animatedValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Garante que o valor final seja exato
        setDisplayValue(targetValue);
        prevValueRef.current = targetValue;
      }
    };

    requestAnimationFrame(animate);

    // Atualiza o valor de referência para a próxima mudança
    return () => { prevValueRef.current = targetValue };

  }, [targetValue, duration]);

  return displayValue;
};

export default useAnimatedCounter;